import './App.css';
import './fog.css';
import HomePage from './components/HomePage'
import WelcomePage from './components/WelcomePage';
import ResourcesPage from './components/ResourcesPage';
import LecturesPage from './components/LecturesPage';
import AssignmentsPage from './components/AssignmentsPage';
import HoursPage from './components/HoursPage';
import StaffPage from './components/StaffPage';
import Nav from './components/Nav';

function App() {
  return (
    <div className="App">
      <Nav />
      <HomePage />
      <WelcomePage />
      <LecturesPage />
      <AssignmentsPage/> 
      <ResourcesPage />
      <HoursPage />
      <StaffPage />
    </div>
  );
}

export default App;
